import { createContext, useContext } from 'react';
import clsx from 'clsx';
import { OmitMethods } from '../../types/omit-methods';
import './tabs.scss';

interface Components {
	Tab: typeof Tab;
}

interface TabsProps {
	value?: any;
	onChange?: (value?: any) => void;
}

interface TabsContextI {
	value?: any;
	onClick?: (value?: any) => void;
}

const initialState: OmitMethods<TabsContextI> = {};

const TabsContext = createContext<TabsContextI>(initialState as TabsContextI);

const Tabs: React.FunctionComponent<TabsProps> & Components = ({ value, children, onChange: onClick }) => {
	return (
		<TabsContext.Provider value={{ value, onClick }}>
			<ul className="tabs">{children}</ul>
		</TabsContext.Provider>
	);
};

interface TabProps {
	value?: any;
	onClick?: (value?: any) => void;
}

const Tab: React.FunctionComponent<TabProps> = ({ value, children, onClick }) => {
	const tabsContext = useContext(TabsContext);

	function onClickMiddleware() {
		tabsContext.onClick?.(value);
		onClick?.(value);
	}

	return (
		<li className={clsx('tabs__tab', { active: value === tabsContext.value })} onClick={onClickMiddleware}>
			{children}
		</li>
	);
};

Tabs.Tab = Tab;

export default Tabs;
